import { render, staticRenderFns } from "./KnFormOrder.vue?vue&type=template&id=119a922a&"
import script from "./KnFormOrder.vue?vue&type=script&lang=js&"
export * from "./KnFormOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports